module.exports = __webpack_public_path__ + "img/activities-18.f562195f.jpg";